export default function CreditCard(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='42'
      height='33.264'
      viewBox='0 0 42 33.264'
      fill='#152a46'
      {...props}
    >
      <path
        id='credit_card'
        data-name='credit card'
        d='M36.75,0H5.25A5.073,5.073,0,0,0,1.518,1.518,5.073,5.073,0,0,0,0,5.25v21A5.055,5.055,0,0,0,1.518,30,5.109,5.109,0,0,0,5.25,31.5h31.5A5.109,5.109,0,0,0,40.482,30,5.055,5.055,0,0,0,42,26.25v-21a5.073,5.073,0,0,0-1.518-3.732A5.073,5.073,0,0,0,36.75,0ZM5.25,3.527h31.5A1.762,1.762,0,0,1,38.021,4a1.653,1.653,0,0,1,.492,1.251V10.5H3.486V5.25A1.653,1.653,0,0,1,3.979,4,1.762,1.762,0,0,1,5.25,3.527Zm31.5,24.486H5.25a1.762,1.762,0,0,1-1.271-.472,1.7,1.7,0,0,1-.492-1.292V14.027H38.514V26.25a1.7,1.7,0,0,1-.492,1.292A1.762,1.762,0,0,1,36.75,28.014ZM42,33.264'
      />
    </svg>
  )
}
